import React from 'react';

const ProductVersion = () => (
  <div className="ProductVersion">
        SES Direct V2 <br />Release: 1
  </div>
);


export default ProductVersion;
